import { styled, TableCell, TableRow, tableCellClasses } from 'ui';

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  padding: theme.spacing(1.25),
  [`&.${tableCellClasses.head}`]: {
    color: theme.palette.text.secondary,
  },
}));

export const StyledTableRow = styled(TableRow, {
  shouldForwardProp: (prop) => prop !== 'clickableRow',
})<{ clickableRow?: boolean }>(({ clickableRow }) => ({
  ':hover': {
    backgroundColor: clickableRow ? 'rgba(0, 0, 0, 0.04)' : 'transparent',
    cursor: clickableRow ? 'pointer' : 'default',
  },
}));
